// extracted by mini-css-extract-plugin
export var centerText = "_c8-8";
export var container = "_c8-0";
export var doughnutContainer = "_c8-7";
export var legend = "_c8-a";
export var legendItemColorDisplay = "_c8-b";
export var legendItemLabel = "_c8-d";
export var legendItemValue = "_c8-c";
export var lg = "_c8-5";
export var maxWidth = "_c8-9";
export var md = "_c8-4";
export var responsive = "_c8-6";
export var sm = "_c8-3";
export var xs = "_c8-2";
export var xxs = "_c8-1";